import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState } from "../../../../toolkit/uicomponent";
import { AlertType } from "../../../../toolkit/alert/alerttype";
import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentView } from "../../../../toolkit/uicomponentview";
import { UIComponentCSSStyle } from "../../../../toolkit/uicomponentcss";
import { SetFlashMessageViewImpl } from "./setflashmessageview";
import { SetFlashMessageCSSStyleImpl } from "./setflashmessagecss";
import { DedicateFlashDto, FlashMessageDto } from "src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto";
import { SetFlashMessageAPIModel, SetFlashMessageAPIModelImpl } from "./setflashmessageapimodel";
import { APIModelHandler, APIModel } from "../../../../toolkit/uicomponentapimodel";
import { APIFeatures } from "src/com/sixdee/crbtportal/core/util/apifeatures";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { FlashMessageSubscriptionDetailsDto } from "src/com/sixdee/crbtportal/core/dto/flashsubscriptiondetails/flashmessagedetails";

export interface SetFlashMessageComponentProps extends UIComponentProps
{
    flashMessageDto: FlashMessageDto;
    closePopup(): void;
    showSubscriptionDetails(flashMessageDto: FlashMessageDto): void;
    showPopup(id:string,msg:string,type:AlertType):void;
}

export interface SetFlashMessageComponentState extends  UIComponentState
{
   
    isAllCallersSelected: boolean;
}

export interface SetFlashMessageComponentHandler extends UIComponentHandler
{
    onNextClick(): void;
    onTabSelected(isAllCallersSelected: boolean): void;
}

export class SetFlashMessageComponent extends UIComponentImpl<SetFlashMessageComponentProps, SetFlashMessageComponentState, FlashMessageDto> 
implements SetFlashMessageComponentHandler
{
    constructor(props: SetFlashMessageComponentProps, state:SetFlashMessageComponentState)
    {
        super(props);

        this.state= {isAllCallersSelected: true};
    }
    onTabSelected(isAllCallersSelected: boolean): void 
    {
        this.setState({isAllCallersSelected: isAllCallersSelected});
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<FlashMessageDto>
    {
        return new SetFlashMessageViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new SetFlashMessageCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new SetFlashMessageAPIModelImpl(applicationContext, apiModelHandler);
    }

    onNextClick()
    {     
          if(!this.getContext().getUserContext().getIsLoggedIn())
          { 
            if((this.getView() as SetFlashMessageViewImpl).validate())
            {
                (this.getView() as SetFlashMessageViewImpl).showLoader(); 
                (this.getAPIModel() as SetFlashMessageAPIModel).validateSubscriber(
                    (this.getView() as SetFlashMessageViewImpl).getMSISDNData());
            }
          }
          else
          {
            
            this.props.flashMessageDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
            if(this.state.isAllCallersSelected)
            {
                (this.getView() as SetFlashMessageViewImpl).showLoader();   
                (this.getAPIModel() as SetFlashMessageAPIModel).getSubscriberDetails(this.props.flashMessageDto);
            }
            else{
                if((this.getView() as SetFlashMessageViewImpl).validateSpecialCaller())
                {
                    (this.getView() as SetFlashMessageViewImpl).showLoader();   

                    let dedicateMsisdn = (this.getView() as SetFlashMessageViewImpl).getSpecialCallerData();
                    this.props.flashMessageDto.getDedicateFlashDtos().push(
                        new DedicateFlashDto("0", "Dedicate Note4U", 
                        dedicateMsisdn, this.props.flashMessageDto.getStatusMessage()));
                    (this.getAPIModel() as SetFlashMessageAPIModel).getSubscriberDetails(this.props.flashMessageDto);
                }
            }
          }
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("onSuccess" + feature); 
        if(feature === APIFeatures.GET_FLASH_SUBSCRIPTION)
        {
            if(!(data as FlashMessageSubscriptionDetailsDto).isNewUser())
            {
                this.props.flashMessageDto.setPlanName((data as FlashMessageSubscriptionDetailsDto).getPlanName());
                if(this.state.isAllCallersSelected)
                {
                    (this.getAPIModel() as SetFlashMessageAPIModel).setFlashMessage(this.props.flashMessageDto);
                }
                else
                {
                    (this.getAPIModel() as SetFlashMessageAPIModel).setSpecialCallerFlashMessage(this.props.flashMessageDto);
                }
            }
            else
            {
                (this.getView() as SetFlashMessageViewImpl).dismissLoader();  
                this.props.flashMessageDto.setIsAllCallers(this.state.isAllCallersSelected);
                this.props.showSubscriptionDetails(this.props.flashMessageDto);
            }
        }
        else if(feature === APIFeatures.SUBSCRIBER_VALIDATION)
        {
            console.log("SUBSCRIBER_VALIDATION" + feature); 
            this.props.flashMessageDto.setMsisdn(data as string);
            (this.getAPIModel() as SetFlashMessageAPIModel).getSubscriberDetails(this.props.flashMessageDto);
        }
        else if(feature === APIFeatures.SET_FLASH_MESSAGE)
        {
            (this.getView() as SetFlashMessageViewImpl).dismissLoader();  
            this.props.showPopup("Set Note4U", this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),
            AlertType.SUCCESS);
        }
        else if(feature === APIFeatures.DEDICATE_FLASH_MESSAGE)
        {
            (this.getView() as SetFlashMessageViewImpl).dismissLoader();  
            this.props.showPopup("Dedicate Note4U", this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),
            AlertType.SUCCESS);
        }
    }
    
    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        (this.getView() as SetFlashMessageViewImpl).dismissLoader();  

        this.props.showPopup("Set Note4U",
            description,AlertType.ERROR);
    }            
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/setflashmessage/setflashmessagecomponent.tsx